import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {Routes} from '../../../../../commons/enums'
import {useMembersPageActions, useMembersPageSelector} from '../../hooks/runtime'
import {getEventOrders} from '../../selectors/event'
import {getRouteParams} from '../../selectors/navigation'
import {Back} from '../back'
import s from './mobile-order-list.scss'
import {OrderRow} from './order-row'

export const MobileOrderList = () => {
  const {t} = useTranslation()
  const {event} = useMembersPageSelector(getRouteParams)
  const orders = getEventOrders(event)

  const {internalNavigate} = useMembersPageActions()

  return (
    <div className={s.root}>
      <Back onClick={() => internalNavigate({route: Routes.DEFAULT})} t={t} />
      {orders.map((order: wix.events.ticketing.Order, idx: number) => (
        <OrderRow
          key={order.orderNumber}
          order={order}
          lastRow={idx === orders.length - 1}
          onClick={() => internalNavigate({route: Routes.ORDER, params: {event, order}})}
        />
      ))}
    </div>
  )
}
